import template from './fuel_surcharges.create.html';
import controller from './fuel_surcharges.create.controller';
import './fuel_surcharges.create.scss';

let fuelSurchargesCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default fuelSurchargesCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/create/fuel_surcharges.create.component.js